import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface BreadcrumbAction {
  id: string;
  label: string;
  variant: 'stroked' | 'raised';
  color?: string;
  buttonClass?: 'outline' | 'filled';
}

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbActionsService {
  private readonly actionsSubject = new BehaviorSubject<BreadcrumbAction[]>([]);
  private readonly actionClickSubject = new Subject<string>();

  readonly actions$ = this.actionsSubject.asObservable();
  readonly actionClick$ = this.actionClickSubject.asObservable();

  setActions(actions: BreadcrumbAction[]): void {
    this.actionsSubject.next(actions);
  }

  clearActions(): void {
    this.actionsSubject.next([]);
  }

  notifyAction(id: string): void {
    this.actionClickSubject.next(id);
  }
}
